import PurchaseChallengeInfo from './PurchaseChallengeInfo';

export default PurchaseChallengeInfo;
